export const cnpj = (v) => {
    if (!v) {
        return '';
    }
	return `${v.substring(0,2)}.${v.substring(2,5)}.${v.substring(5,8)}/${v.substring(8,12)}-${v.substring(12,14)}`
}

export const cpfcnpj = (v) => {
    if (!v) {
        return '';
    } else {
            let sem_formatacao =  v.replace(/(\.|\/|\-)/g,"").replace(' ','');

            if (sem_formatacao.length <= 11) {
                return sem_formatacao.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g,"\$1.\$2.\$3\-\$4");
            } else {
                return sem_formatacao.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,"\$1.\$2.\$3\/\$4\-\$5");
            } 
    }
}

export const cpf = (v) => {
    if (!v) {
        return '';
    }
	return `${v.substring(0,3)}.${v.substring(3,6)}.${v.substring(6,9)}-${v.substring(9,11)}`
}

export const cep = (v) => {
    if (!v) {
        return '';
    }
	return `${v.substring(0,2)}.${v.substring(2,5)}-${v.substring(5,8)}`
}

export const tokens = {
    d: {
        pattern: /[0-3]/
    },
    D: {
        pattern: /[1-9]/
    },
    b: {
        pattern: /[0-9]/
    },
    B: {
        pattern: /[0-1]/
    },
    M: {
        pattern: /[1]/
    },
    W: {
        pattern: /[1,3,5,7,8]/
    },
    Q: {
        pattern: /[1,3-9]/
    },
    w: {
        pattern: /[0,2]/
    },
    q: {
        pattern: /[0-2]/
    },
    f: {
        pattern: /[1-9]/
    },
    y: {
        pattern: /[0-9]/
    },
    m: {
        pattern: /[1-7]/
    },
    s: {
        pattern: /[1-7]/
    },
}


export const dateMask = (v, r) => {
    let day = v.substring(0, 2)
    let df = v.charAt(0)
    let t = v.length;
    let dt = day.length;
    let mask = '';
    if (!dt) {
        mask = 'yy/yy/yyyy';
    } else {
        if (df > 3) {
            // r._props.value = '0' + v;
            mask = '0D/y';
        } else if (df < 3) {
            mask = 'db/y';
        } else {
            mask = 'dB/y'
        }
    }

    if (t > 3) {
        let b = mask.substring(0,3);
        let fm = v.charAt(3);
        
        if (day == 31) {
            mask = b + (fm == 1 ? 'Mw' : '0W') + '/yyyy'
        } else if (day == 30) {
            mask = b + (fm == 1 ? 'Mq' : '0Q') + '/yyyy'
        } else {
            mask = b + (fm == 1 ? 'Mq' : '0f') + '/yyyy'
        }
    }
    
    if (r) {
        setTimeout(() => {
            moveCursorToEnd(r.$el)
        }, 100)
    }    
    return mask;
}

export const moveCursorToEnd = (el) => {
    if (typeof el.selectionStart == "number") {
        el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
    }
}



export const leapYear = (year) => {
    return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
}